import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import classNames from 'classnames';
import './styles.scss';

const ExchangePayable = ({ priceDetails }) => {
  const { currency, amount } = priceDetails;
  const isRefund = Number(amount) < 0;
  const titleText = isRefund
    ? I18n.t('components.ibe.exchange.cart.refund')
    : I18n.t('components.ibe.exchange.cart.due');

  return (
    <div
      className={classNames('exchange-payable d-flex justify-between align-center', {
        'exchange-payable--refund': isRefund,
      })}
    >
      <div className="exchange-payable__title">{titleText}</div>
      <Amount className="exchange-payable__amount" currency={currency} value={amount} />
    </div>
  );
};

ExchangePayable.propTypes = {
  priceDetails: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
  }).isRequired,
};

export default ExchangePayable;
